// ============================================================
// Analitik: GA4 (pilihan, ikut REACT_APP_GA4_ID) + kiraan dalaman
// Kalau REACT_APP_GA4_ID tiada, GA4 dilangkau sepenuhnya tanpa
// sebarang permintaan rangkaian atau ralat konsol.
// TIADA data peribadi (nama/e-mel/telefon) dihantar ke GA4.
// ============================================================

const GA_ID = (process.env.REACT_APP_GA4_ID || "").trim();
const gaEnabled = /^G-[A-Z0-9]+$/i.test(GA_ID);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let gaReady = false;
let gaPromise = null;

function sessionId() {
  try {
    let s = sessionStorage.getItem("_sid");
    if (!s) {
      s =
        Math.random().toString(36).slice(2) + Date.now().toString(36).slice(-4);
      sessionStorage.setItem("_sid", s);
    }
    return s;
  } catch {
    return "";
  }
}

function loadGa() {
  if (!gaEnabled || typeof document === "undefined") return Promise.resolve(false);
  if (gaReady) return Promise.resolve(true);
  if (gaPromise) return gaPromise;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: true });

  gaPromise = new Promise((resolve) => {
    if (document.querySelector(`script[data-ga4="${GA_ID}"]`)) {
      gaReady = true;
      return resolve(true);
    }
    const el = document.createElement("script");
    el.async = true;
    el.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_ID)}`;
    el.dataset.ga4 = GA_ID;
    el.onload = () => {
      gaReady = true;
      resolve(true);
    };
    el.onerror = () => resolve(false);
    document.head.appendChild(el);
  });
  return gaPromise;
}

function ga(name, params) {
  if (!gaEnabled || !gaReady) return;
  try {
    window.gtag("event", name, params || {});
  } catch {
    /* analitik tidak boleh menjejaskan aplikasi */
  }
}

function beacon(event, props) {
  try {
    const body = JSON.stringify({
      event,
      props: props || {},
      path: window.location.pathname,
      referrer: document.referrer || "",
      session: sessionId(),
    });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(
        `${API}/track`,
        new Blob([body], { type: "application/json" })
      );
    } else {
      fetch(`${API}/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* abaikan */
  }
}

function isAdminView() {
  try {
    return (
      window.location.pathname.startsWith("/admin") ||
      new URLSearchParams(window.location.search).get("admin") === "1" ||
      window.location.hash === "#admin"
    );
  } catch {
    return false;
  }
}

export function initAnalytics() {
  // Jangan kira lawatan papan admin sebagai trafik pelawat.
  if (isAdminView()) return;
  loadGa();
  beacon("page_view");
}

export function trackTicketClick(location, tier) {
  const props = { button_location: location };
  if (tier) {
    props.tier_name = tier.name;
    if (typeof tier.price === "number") props.price = tier.price;
  }
  ga("beli_tiket", props);
  beacon("beli_tiket", props);
}

export function trackPosterView(posterName) {
  const props = { poster_name: posterName || "unknown" };
  ga("poster_view", props);
  beacon("poster_view", props);
}

export function trackReminderSubmit(tier) {
  const props = { reminder_type: "ticket_release" };
  if (tier) props.tier_name = tier;
  ga("reminder_submit", props);
  beacon("reminder_submit", props);
}

export function trackShare(channel) {
  const props = { channel };
  ga("share_poster", props);
  beacon("share_poster", props);
}

export const analyticsEnabled = gaEnabled;
